const noticeContent = {
  title: '공지사항 관리 매뉴얼',
  content: `
  <div class="page-title">[공지사항 관리]</div>

# [개요]
공지사항 관리는 기업의 주요 공지사항을 효율적으로 관리하고 제공하기 위한 도구입니다. 이 문서에서는 **공지사항의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 공지사항 조회 | 등록된 공지사항 목록 확인 및 검색 | 관리자 |
| 공지사항 등록 | 신규 공지사항 등록 | 관리자 |
| 공지사항 수정 | 기존 공지사항 정보 수정 | 관리자 |

# [조회]
등록된 공지사항의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 목록 영역 | 공지사항 목록 테이블 | • 카테고리/제목 확인<br>• 더블클릭으로 상세 정보 확인 |
| 검색 영역 | 검색 조건 및 필터 | • 카테고리별 필터링<br>• 검색어 기준 검색 |
| 버튼 영역 | 등록 버튼 | • 신규 공지사항 등록 |

![공지사항 목록](/assets/images/guide/notice/list.png)

# [등록/수정]
공지사항을 신규 등록하거나 기존 공지사항의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 이미지는 여러 개 등록 가능합니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 정보 | • 카테고리 | • 공지사항 카테고리 선택 |
| 콘텐츠 | • 제목<br>• 내용<br>• 이미지 | • 공지사항 제목 입력<br>• 공지사항 상세 내용 입력<br>• 관련 이미지 업로드 |

![공지사항 등록/수정](/assets/images/guide/notice/edit.png)
  `,
};

export default noticeContent;
